export enum ServiceStatusOptions {
    Open = 1,
    Canceled = 3
}